import { Component } from '@verndale/core';
import Swiper from 'swiper';
import { Navigation, Keyboard, Pagination, Controller } from 'swiper/modules';
import YouTubeIframeLoader from 'youtube-iframe';

class ResourcesBlock extends Component {
  constructor(el) {
    super(el);
    this.videoId = this.el.dataset.videoId || '';
    this.player = null;
  }

  setupDefaults() {
    this.dom = {
      el: this.el,
      swiperContainer: this.el.querySelector('.swiper'),
      swiperWrapper: this.el.querySelector('.swiper-wrapper'),
      swiperItems: this.el.querySelectorAll('.swiper-slide'),
      nextArrow: this.el.querySelector('.swiper-button-next'),
      prevArrow: this.el.querySelector('.swiper-button-prev'),
      videoSlides: this.el.querySelectorAll('.swiper-slide.video-slide'),
      videoLinks: this.el.querySelectorAll(
        '.swiper-slide.video-slide .resources-block__slide-link'
      ),
      videoButton: this.el.querySelectorAll('.resources-block__video-icon'),
      videoContainer: this.el.querySelector(
        '.resources-block__video-modal .video-container'
      ),
      videoModal: this.el.querySelector('.resources-block__video-modal'),
      closeModalBtn: this.el.querySelector('.close'),
      modalTitle: this.el.querySelector('.resources-block__modal-title')
    };

    this.initSwiper();
  }

  addListeners() {
    this.dom.videoLinks.forEach(slide => {
      slide.addEventListener('click', this.handleVideoSlideClick.bind(this));
    });
    this.dom.videoButton.forEach(slide => {
      slide.addEventListener('click', this.handleVideoBtnClick.bind(this));
    });
    this.dom.closeModalBtn.addEventListener('click', () => {
      if (this.player) {
        this.player.pauseVideo();
        this.dom.videoModal.close();
        document.body.style.overflow = 'auto';
      }
    });
    this.dom.videoModal.addEventListener('click', this.handleClickOutside.bind(this));
  }

  initSwiper() {
    Swiper.use([Navigation, Keyboard, Pagination, Controller]);

    new Swiper(this.dom.swiperContainer, {
      navigation: {
        nextEl: this.dom.nextArrow,
        prevEl: this.dom.prevArrow
      },
      slidesPerView: 1.1,
      spaceBetween: 24,
      loop: true,
      breakpoints: {
        768: {
          slidesPerView: 3.2,
          spaceBetween: 16
        }
      }
    });
  }

  handleClickOutside(e) {
    if (e.target === e.currentTarget) {
      e.stopPropagation();
      if (this.player) {
        this.player.pauseVideo();
      }
      e.target.close();
      document.body.style.overflow = 'auto';
    }
  }

  handleVideoSlideClick(e) {
    e.preventDefault();
    const target = e.currentTarget;
    const videoContainer = this.el.querySelector(
      '.resources-block__video-modal .resources-block__modal-content .video-container'
    );
    this.videoId = target.parentElement?.dataset.videoId || '';
    const cardTitle = target.parentElement?.querySelector(
      '.resources-block__slide-title'
    )?.textContent;
    this.dom.modalTitle.textContent = cardTitle || '';

    if (videoContainer?.tagName === 'DIV') {
      YouTubeIframeLoader.load(YT => {
        this.player = new YT.Player(
          this.el.querySelector('.resources-block__video-modal .video-container'),
          {
            width: '100%',
            height: '100%',
            videoId: this.videoId
          }
        );
      });
    } else if (videoContainer?.tagName === 'IFRAME' && videoContainer.parentElement) {
        videoContainer.parentElement.innerHTML = `<div class="video-container"></div>`;
        YouTubeIframeLoader.load(YT => {
          this.player = new YT.Player(
            this.el.querySelector('.resources-block__video-modal .video-container'),
            {
              width: '100%',
              height: '100%',
              videoId: this.videoId
            }
          );
        });
      }

    this.dom.videoModal.showModal();
    document.body.style.overflow = 'hidden';
  }

  handleVideoBtnClick(e) {
    const target = e.currentTarget;
    const videoContainer = this.el.querySelector(
      '.resources-block__video-modal .resources-block__modal-content .video-container'
    );
    this.videoId = target.parentElement?.parentElement?.dataset.videoId || '';
    const cardTitle = target.parentElement?.parentElement?.querySelector(
      '.resources-block__slide-title'
    )?.textContent;
    this.dom.modalTitle.textContent = cardTitle || '';

    if (videoContainer?.tagName === 'DIV') {
      YouTubeIframeLoader.load(YT => {
        this.player = new YT.Player(
          this.el.querySelector('.resources-block__video-modal .video-container'),
          {
            width: '100%',
            height: '100%',
            videoId: this.videoId
          }
        );
      });
    } else if (videoContainer?.tagName === 'IFRAME' && videoContainer.parentElement) {
        videoContainer.parentElement.innerHTML = `<div class="video-container"></div>`;
        YouTubeIframeLoader.load(YT => {
          this.player = new YT.Player(
            this.el.querySelector('.resources-block__video-modal .video-container'),
            {
              width: '100%',
              height: '100%',
              videoId: this.videoId
            }
          );
        });
      }

    this.dom.videoModal.showModal();
    document.body.style.overflow = 'hidden';
  }
}

export default ResourcesBlock;
